module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-6.d4db4745.png";